<template>
    <!-- Строки откликов не интерактивны. Статус — серверный, не пересчитывается. -->
    <div class="ds-dossier-responses">
        <div v-for="item in responses" :key="item.id" class="ds-dossier-response">
            <span class="ds-dossier-muted">{{ dayjs(item.respondedAt.slice(0, 10)).format('DD.MM') }}</span>
            <span>
                <b>{{ item.departmentName || DASH }}</b><br>
                <span class="ds-dossier-muted">{{ details(item) }}</span>
            </span>
            <span class="ds-dossier-pill" :class="STATUS_CLASS[item.status]">{{ RESPONSE_STATUS_LABELS[item.status] }}</span>
        </div>
    </div>
</template>

<script setup lang="ts">
import dayjs from 'dayjs'
import { DASH } from './dossierModel'
import { type ExchangeResponse, type ResponseStatus, RESPONSE_STATUS_LABELS, timeRange } from './dossierActivity'

defineProps<{ responses: ExchangeResponse[] }>()

const STATUS_CLASS: Record<ResponseStatus, string> = {
    pending: 'ds-dossier-pill-pending',
    approved: 'ds-dossier-pill-approved',
    rejected: 'ds-dossier-pill-rejected',
    worked: '',
    no_show: 'ds-dossier-pill-no-show',
}

// Должность · дата смены, время по плану (из смены или вакансии; может отсутствовать).
const details = (item: ExchangeResponse) => {
    const shift = [item.shiftDate ? dayjs(item.shiftDate).format('DD.MM') : null, timeRange(item.planStart, item.planEnd)].filter(Boolean).join(', ')
    return [item.positionName || DASH, shift || null].filter(Boolean).join(' · ')
}
</script>
